import { render, staticRenderFns } from "./productsearchinput.vue?vue&type=template&id=182cdcb3&"
import script from "./productsearchinput.vue?vue&type=script&lang=ts&"
export * from "./productsearchinput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('182cdcb3')) {
      api.createRecord('182cdcb3', component.options)
    } else {
      api.reload('182cdcb3', component.options)
    }
    module.hot.accept("./productsearchinput.vue?vue&type=template&id=182cdcb3&", function () {
      api.rerender('182cdcb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/products/productsearchinput.vue"
export default component.exports